import { api } from './client';
import type { Difficulty, SerializedBoardDto } from './puzzles';

export interface SolutionLine {
  total_score: number;
  words: Array<{ word: string; score: number }>;
  board: SerializedBoardDto;
}

export interface SolutionView {
  target_score: number;
  optimal_score: number;
  lines: SolutionLine[];
}

export async function fetchSolution(date: string, difficulty: Difficulty): Promise<SolutionView> {
  const res = await api.get(`/api/puzzles/${date}/${difficulty}/solution`);
  return res.data;
}
